import React from 'react';

const DemoAcceleratorCard = ({ accelerator, onClick }) => {
  const handleTitleClick = (e) => {
    e.stopPropagation();
    if (accelerator.demo_url) {
      window.open(accelerator.demo_url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div 
      className="bg-white rounded-lg shadow-md p-3 card-hover cursor-pointer h-full flex flex-col"
      onClick={() => onClick(accelerator)}
    >
      {/* Header: Title as Hyperlink */}
      <div className="mb-2">
        <h3 
          className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer leading-tight"
          onClick={handleTitleClick}
        >
          {accelerator.name}
        </h3>
      </div>
    </div>
  );
};

export default DemoAcceleratorCard;


